import React from 'react';
import { Mail, Sparkles } from 'lucide-react';

interface EmailPreviewProps {
  emailTemplate: string;
  recipientEmail?: string;
  enhancedDescription?: string;
}

export default function EmailPreview({ emailTemplate, recipientEmail, enhancedDescription }: EmailPreviewProps) {
  // Split the template into parts
  const lines = emailTemplate.split('\n');
  
  // Extract sender line and subject line
  const sender = lines[0];
  const subject = lines.length > 1 && lines[1].startsWith('Subject:') 
    ? lines[1].substring(8).trim() 
    : 'New Campaign Update';
  
  // Get the body (everything after the first two lines)
  const body = lines.slice(2).join('\n');

  // Replace {{recipient}} placeholders with the actual recipient email or a placeholder
  const personalizedBody = body.replace(
    /\{\{recipient\}\}/g, 
    recipientEmail || 'example@example.com'
  );

  return (
    <div className="bg-white border rounded-lg overflow-hidden">
      <div className="bg-gray-50 px-4 py-3 border-b">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Mail className="h-5 w-5 text-gray-400 mr-2" />
            <div>
              <h3 className="text-sm font-medium">Email Preview</h3>
              {recipientEmail && (
                <p className="text-xs text-gray-500">To: {recipientEmail}</p>
              )}
            </div>
          </div>
          
          {enhancedDescription && (
            <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full flex items-center">
              <Sparkles className="h-3 w-3 mr-1" /> AI Enhanced
            </span>
          )}
        </div>
      </div>
      
      <div className="p-4">
        <div className="mb-3 pb-3 border-b">
          <div className="text-sm font-medium">From: {sender}</div>
          <div className="text-sm text-gray-700 font-medium">Subject: {subject}</div>
        </div>
        
        <div className="text-sm whitespace-pre-line">
          {personalizedBody}
        </div>
      </div>
    </div>
  );
}